import { render, staticRenderFns } from "./SimpleMessage.vue?vue&type=template&id=626ad690&"
import script from "./SimpleMessage.vue?vue&type=script&lang=js&"
export * from "./SimpleMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports